import { render, staticRenderFns } from "./AllMitra.vue?vue&type=template&id=039095d1&"
import script from "./AllMitra.vue?vue&type=script&lang=js&"
export * from "./AllMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports